import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {OkCancelDialog} from '../../../../libs/shared/ui/src/components/dialogs/okCancelDialog';

/*
 * Props.
 */

interface DeleteSchedulingLinkDialogProps {
  onConfirmClick: () => void;
  onRequestClose: () => void;
}

/*
 * Component.
 */

export const DeleteSchedulingLinkDialog: FC<DeleteSchedulingLinkDialogProps> = (props) => (
  <OkCancelDialog
    title={<Trans id="delete-schedulinglink-title">Delete scheduling link</Trans>}
    okButtonLabel={<Trans id="delete-schedulinglink-delete">Delete</Trans>}
    onOkClick={props.onConfirmClick}
    onRequestClose={props.onRequestClose}
  >
    <Trans id="delete-schedulinglink-warning">
      Are you sure you want to delete this scheduling link? This action cannot be undone.
    </Trans>
  </OkCancelDialog>
);
